
import * as React from 'react';
import HighMap from 'highcharts/highmaps';
import HighchartsReact  from 'highcharts-react-official';
import HighchartMore from 'highcharts/highcharts-more';
import ChartTheme from '../chartTheme';

(window as any).HighMap = HighMap;
HighchartMore(HighMap);
require('highcharts/modules/map')(HighMap);
require('highcharts/modules/exporting')(HighMap);
require('highcharts/modules/offline-exporting')(HighMap);
HighMap.setOptions(ChartTheme as any);

const MapChart = ({ options, refs, callback }) => (
  <HighchartsReact
    highcharts={HighMap}
    constructorType={'mapChart'}
    options={options}
    ref={refs}
    callback={callback}
  />
);
export default MapChart;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSChart/components/Map.tsx